import { FilterContext } from "@/types/websiteInfo"
import { OnLiveEvents } from "@/types/sports"
import { EventTypeConst } from "@common_lib/base/constants/eventTypeConst"

// An event label merged with its event type's constants (value / name / context).
interface EventLabelFilter extends FilterContext, EventTypeConst {
  onClick: (filter: EventLabelFilter) => void
  icon: string
  mode: "custom" | "eventType"
}

const useNavbarStore = defineStore("navbar", () => {
  const eventLabel = ref<FilterContext[]>([])
  const onLiveEventsList = ref(new Map())

  const selectItem = ref<EventLabelFilter | null>(null)
  const handleChangeNavbarSelect = <T extends EventLabelFilter>(item: T) => {
    if (selectItem.value === item) return

    selectItem.value = item
  }

  const clearSelectItem = () => {
    selectItem.value = null
  }

  const updateEventLabel = (list: FilterContext[]) => {
    eventLabel.value = list
  }

  const updateOnLiveEventsList = (data: OnLiveEvents) => {
    onLiveEventsList.value = data.reduce((hash, node) => {
      hash.set(node.eventType, node.count)

      return hash
    }, new Map())
  }

  return {
    selectItem,
    eventLabel,
    onLiveEventsList,
    updateOnLiveEventsList,
    updateEventLabel,
    clearSelectItem,
    handleChangeNavbarSelect
  }
})

export default useNavbarStore
